import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import BookingList from '../../components/Entity/Booking/List/List';
  
const BookingPage = () => {
  return <Layout fullwidth={0}>
   
      <BookingList></BookingList>
     
  </Layout>;
}

export default BookingPage;